import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Animals from "@/pages/Animals";
import Adoptables from "@/pages/Adoptables";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";

function SmoothScroll() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);
  return null;
}

function App() {
  return (
    <div className="App relative">
      <BrowserRouter>
        <SmoothScroll />
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/animals" element={<Animals />} />
            <Route path="/adoptables" element={<Adoptables />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFFF0",
              color: "#294332",
              border: "1px solid rgba(169,190,157,0.6)",
              borderRadius: "16px",
              fontFamily: "Figtree, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
